import React, { useEffect, useContext,  useState } from "react";
import { Button, Modal } from "react-bootstrap";

import './RunValidationChecksModal.scss';
import ReportTable from "./ReportTable";

const RunValidationChecksModal = ({ isOpenRunValidationChecksModal, setOpenRunValidationChecksModal, runValidationChecksReportData }) => {
    const proceedHandler = ()=> {
      setOpenRunValidationChecksModal(false);   
    }
    return (
        <div>
             <Modal
                show={isOpenRunValidationChecksModal}
                fullWidth={true}
                size="lg"
                centered
                className="run-validation-check-modal"
            >
                <Modal.Header className="run-validation-check-modal-header d-flex align-items-center ">
                    <div className="">
                        <Modal.Title className="run-validation-check-modal-header-title_1">Must Exist Elements Not Used</Modal.Title>
                        <div className="d-flex align-items-center">
                            <h3 className="run-validation-check-modal-header-title_2">Following Must Exist Elements are not used to author e-Detail</h3>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="run-validation-check-modal-body">
                    <div className="run-validation-check-modal-content">
                        <ReportTable reportData={runValidationChecksReportData} />
                    </div>
                </Modal.Body>
                <Modal.Footer className="shared-modal-footer">
                    <div className="shared-modal-footer-content">
                        <div><Button className="shared-modal-back" style={{visibility:'hidden'}}>BACK</Button></div>
                        <div> {/* <Button className="shared-modal-cancel" style={{visibility:modeFrom ==='Edit'?'visible':'hidden'}} onClick={clearAll}>CANCEL</Button> */}
                            <Button className="shared-modal-next" onClick={proceedHandler}>CLOSE</Button>
                            </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default RunValidationChecksModal;